import React, { Component } from 'react';
import $ from 'jquery'
class Footer extends Component {
    render() {
        
        return (
            <div>
                <div className="footer">
                    <p>Copyright © Oxygen Global 2018. All rights reserved.</p>
                </div>
            </div>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/footer.jsx